// src/components/Footer.js
import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer text-center py-4">
      <div className="container">
        <p>&copy; 2017 LawFirm. All rights reserved.</p>
        <p>Chamber No. : 126, 1<sup>st</sup> Floor, S Block, Delhi High Court</p>
        <p>Corporate Office : 101, 1st Foor, A-32 Patparganj, Mayur Vihar Phase-1, Delhi-110091</p>
        <p>Corporate Office : H-44, 2nd Floor, BSI Business Park,  Sector-63, Noida, U.P-201301</p>
        <p>Email: contactlegaltrails@gmail.com</p>
        <p>Phone: 9999874193, 8448732066 </p>

      </div>
    </footer>
  );
}

export default Footer;
